import { Calendar } from 'lucide-react';

/**
 * OnThisDayInline — surfaces alongside the Picture Show in the same era-moment
 * context per Lead Phase 1.5 brief: "On This Day surfaces alongside Picture
 * Show in the same era-moment context."
 *
 * Rendered only when there are family birthday matches; falsy events array
 * returns null so the strip is opt-in by data, not by UI toggle.
 */
export default function OnThisDayInline({ events, era }) {
  if (!events || events.length === 0) return null;
  return (
    <div
      className="border-l-2 px-4 py-3 my-5 flex items-start gap-3"
      style={{ borderColor: era.primary, background: `${era.primary}06` }}
      data-testid="on-this-day-inline"
    >
      <Calendar size={16} className="flex-shrink-0 mt-0.5" style={{ color: era.primary }} />
      <div className="flex-1 space-y-1.5">
        <p className="font-hud text-[9px] tracking-widest uppercase" style={{ color: era.primary }}>
          ON THIS DAY — IN YOUR FAMILY
        </p>
        {events.map((evt, i) => (
          <p key={i} className="font-mono text-[12px] text-white/85 leading-snug">
            <span className="text-[#D4A84A]">{evt.name}</span>
            {evt.type === 'family_birthday' && evt.date && (<> &mdash; born this day, {evt.date}</>)}
          </p>
        ))}
      </div>
    </div>
  );
}
